import { graphql } from "gql";

const MESSAGE_WITH_MESSAGE_THREAD_QUERY = graphql(`
  query MessageWithMessageThread($id: ID!) {
    messages(id: [$id]) {
      ...Message
      messageThread {
        ...MessageThread
      }
    }
  }
`);

export default MESSAGE_WITH_MESSAGE_THREAD_QUERY;
